<template>
  <div class="psihologi">
    <HeaderComponent/>

    <main class="content">
      <section class="team-info">
        <h1>Echipa/Psihologi</h1>
        <ul>
          <li>Membri ai Asociației de Psihoterapii Cognitive și Comportamentale din România și ai Colegiului Psihologilor din România</li>
          <li>Echipa noastră de psihologi participă periodic la conferințe naționale și internaționale și la programe de formare profesională continuă, pentru a ne asigura că metodele și tehnicile utilizate în practica noastră sunt mereu actualizate, conforme cu cele mai recente cercetări din domeniu. În plus, lucrăm în parteneriat cu medici neurologi și psihiatri, pentru a oferi soluții integrate și personalizate. Această abordare interdisciplinară ne permite să răspundem eficient nevoilor complexe ale clienților noștri, asigurând o îngrijire psihologică de cea mai înaltă calitate.</li>
        </ul>
      </section>

      <section class="psychologists">
        <div class="psychologist-card">
          <div class="photo">
            <img src="../assets/nico-profile.jpg"
                 alt="Nicoleta Presecan psiholog">
          </div>
          <div class="details">
            <div class="title-section">
              <h3>Nicoleta Presecan</h3>
              <p>-psiholog clinician, specialist consiliere psihologică cognitiv-comportamentală</p>
              <div class="email-button-row">
                <p class="email">nicolpresecan@gmail.com</p>
                <button class="read-more"
                        @click="toggleDetails('nicoleta')">
                  {{ detailsShown.nicoleta ? 'Ascunde detalii' : 'Detalii' }}
                </button>
              </div>
            </div>

            <div class="extended-details"
                 v-if="detailsShown.nicoleta">
              <h4>Studii</h4>
              <ul>
                <li>Facultatea de Psihologie și Științe ale Educației, Universitatea Babeș-Bolyai Cluj-Napoca</li>
                <li>Master - Consiliere Genetică, Universitatea Babeș-Bolyai Cluj-Napoca</li>
                <li>Master - Psihologie clinică, consiliere psihologică și psihoterapie, Universitatea Lucian Blaga Sibiu</li>
              </ul>

              <h4>Certificări profesionale</h4>
              <ul>
                <li>Terapia depresiei în secolul XXI. Noi proceduri și tehnologii: DEPRETER</li>
                <li>Procesele ACT și procesele din Terapia centrată pe Scheme în problemele de relaționare</li>
                <li>Terapia anxietății în secolul 21. Noi proceduri și tehnologii: PAXONLINE</li>
                <li>Licențiere în utilizarea platformelor de evaluare pentru adulți Cognitrom</li>
                <li>Evaluarea psihologică (computerizată) a copiilor și adolescenților</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="psychologist-card">
          <div class="photo">
            <img src="../assets/anamaria-barloiu.jpg"
                 alt="Anamaria Bârloiu psiholog">
          </div>
          <div class="details">
            <div class="title-section">
              <h3>Anamaria Bârloiu</h3>
              <p>-psiholog clinician, competențe în evaluare clinică și intervenție psihologică primară pentru adulți, copii și adolescenți</p>
              <div class="email-button-row">
                <p class="email">anamariabarloiu@gmail.com</p>
                <button class="read-more"
                        @click="toggleDetails('anamaria')">
                  {{ detailsShown.anamaria ? 'Ascunde detalii' : 'Detalii' }}
                </button>
              </div>
            </div>

            <div class="extended-details"
                 v-if="detailsShown.anamaria">
              <h4>Studii</h4>
              <ul>
                <li>Facultatea de Psihologie, City University of New York, Hunter College, cu specializare in psihologie clinică</li>
                <li>Masterand - Psihologie clinică, consiliere psihologică și psihoterapie, Universitatea Lucian Blaga Sibiu</li>
              </ul>

              <h4>Certificări profesionale</h4>
              <ul>
                <li>Evaluarea psihologică a copiilor și adolescenților. Licențiere în utilizarea platformei computerizate Cognikit</li>
                <li>Metode și tehnici de evaluare și psihodiagnostic la adulți și copii în conformitate cu DSM-V</li>
                <li>Procesele ACT și procesele din Terapia centrată pe Scheme în problemele de relaționare</li>
                <li>Certificare Cognitrom Career Planner - evaluarea intereselor și aptitudinilor copiilor și adolescenților în vederea conturării unei perspective realiste asupra viitorului școlar și profesional</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="psychologist-card">
          <div class="photo">
            <img src="../assets/bog-profile.jpg"
                 alt="Bogdan Presecan psiholog">
          </div>
          <div class="details">
            <div class="title-section">
              <h3>Bogdan Presecan</h3>
              <p>-psiholog clinician, specialist consiliere psihologică cognitiv-comportamentală</p>
              <p>Psiholog cu drept de liberă practică atestat în domeniul apărării naționale</p>
              <div class="email-button-row">
                <p class="email">bogdanpresecan@gmail.com</p>
                <button class="read-more"
                        @click="toggleDetails('bogdan')">
                  {{ detailsShown.bogdan ? 'Ascunde detalii' : 'Detalii' }}
                </button>
              </div>
            </div>

            <div class="extended-details"
                 v-if="detailsShown.bogdan">
              <h4>Studii</h4>
              <ul>
                <li>Facultatea de Psihologie și Științe ale Educației, Universitatea Babeș-Bolyai Cluj-Napoca</li>
                <li>Master – Psihologia sănătății publice și clinice, Universitatea Babeș-Bolyai Cluj-Napoca</li>
                <li>Master - Medicină Legală si Criminalistica. Evaluare si Intervenție, Universitatea Lucian Blaga Sibiu</li>
              </ul>

              <h4>Certificări profesionale</h4>
              <ul>
                <li>Terapia depresiei în secolul XXI. Noi proceduri și tehnologii: DEPRETER</li>
                <li>Procesele ACT și procesele din Terapia centrată pe Scheme în problemele de relaționare</li>
                <li>Terapia anxietății în secolul 21. Noi proceduri și tehnologii: PAXONLINE</li>
                <li>Licențiere în utilizarea platformei de evaluare a dezvoltării pentru copii și adolescenți PEDb</li>
                <li>Licențiere în utilizarea platformelor de evaluare pentru adulți Cognitrom</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </main>
    <FooterComponent />
  </div>
</template>

<script>
  import HeaderComponent from "../components/HeaderComponent.vue";
  import FooterComponent from "../components/FooterComponent.vue";

  export default {
    name: 'Psihologi',
    components: {FooterComponent, HeaderComponent},
    data () {
      return {
        detailsShown: {
          nicoleta: false,
          anamaria: false,
          bogdan: false
        }
      };
    },
    methods: {
      toggleDetails (person) {
        this.detailsShown[person] = !this.detailsShown[person];
      }
    }
  };
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $primary-color-dark: #1a2b53;
  $text-color: #333;
  $border-light: #eee;
  $white: white;
  $main-font-family: 'Roboto', sans-serif;

  @media only screen and (min-width: 0px) {
    .psihologi {
      font-family: $main-font-family;
      font-weight: 200;
      font-size: 22px;
      color: $text-color;
      margin-top: 80px;

      .content {
        max-width: 100%;
        margin: 20px auto;
        padding: 0 15px 40px;
      }

      .team-info {
        margin-bottom: 30px;

        h1 {
          font-size: 38px;
          margin-bottom: 15px;
          color: $primary-color;
          text-align: center;
        }

        ul {
          padding-left: 20px;
          text-align: left;

          li {
            margin-bottom: 15px;
            font-size: 22px;
            line-height: 1.6;
          }
        }
      }

      .psychologists {
        .psychologist-card {
          display: flex;
          flex-direction: column;
          margin-bottom: 40px;
          border-bottom: 1px solid $border-light;
          padding-bottom: 25px;
          position: relative;

          .photo {
            width: 100%;
            max-width: 220px;
            margin: 0 auto 20px;

            img {
              width: 100%;
              border-radius: 4px;
              box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            }
          }

          .details {
            text-align: left;
            position: relative;

            .title-section {
              margin-bottom: 15px;
              width: 100%;
            }

            .email-button-row {
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              margin-top: 10px;

              .email {
                margin-bottom: 10px;
                font-size: 22px;
                width: 100%;
              }

              .read-more {
                width: 100%;
              }
            }

            h3 {
              font-size: 26px;
              margin-bottom: 5px;
              text-align: center;
            }

            h4 {
              font-size: 24px;
              margin: 18px 0 8px;
              text-align: left;
              color: $primary-color;
            }

            p {
              font-size: 22px;
              margin-bottom: 10px;
              line-height: 1.5;
              text-align: left;
              width: 100%;
            }

            .email {
              color: $primary-color;
              font-weight: 400;
              font-size: 22px;
              text-align: center;
            }

            .extended-details {
              margin-top: 20px;
              margin-bottom: 20px;
              animation: fadeIn 0.3s ease-in-out;
              width: 100%;
            }

            ul {
              padding-left: 20px;
              margin-bottom: 15px;
              text-align: left;

              li {
                font-size: 22px;
                margin-bottom: 8px;
                line-height: 1.5;
                text-align: left;
              }
            }

            .read-more {
              display: inline-block;
              padding: 8px 14px;
              color: $white;
              background-color: $primary-color;
              text-decoration: none;
              font-weight: 500;
              border: none;
              border-radius: 4px;
              cursor: pointer;
              transition: background-color 0.3s;
              font-size: 18px;

              &:hover {
                background-color: $primary-color-dark;
              }
            }
          }
        }
      }
    }
  }

  @media only screen and (min-width: 768px) {
    .psihologi {
      font-size: 22px;

      .content {
        max-width: 1000px;
        margin: 40px auto;
        padding: 0 20px 60px;
      }

      .team-info {
        margin-bottom: 50px;

        h1 {
          font-size: 38px;
          margin-bottom: 20px;
          text-align: center;
        }

        ul li {
          font-size: 22px;
          margin-bottom: 15px;
        }
      }

      .psychologists {
        .psychologist-card {
          flex-direction: row;
          align-items: flex-start;
          margin-bottom: 50px;
          padding-bottom: 30px;

          .photo {
            margin: 0 30px 0 0;
            max-width: 280px;
          }

          .details {
            .email-button-row {
              flex-wrap: nowrap;

              .email {
                margin-bottom: 0;
                width: auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 60%;
                font-size: 22px;
              }

              .read-more {
                width: auto;
                flex-shrink: 0;
                font-size: 22px;
                padding: 8px 16px;
              }
            }

            h3 {
              font-size: 26px;
              margin-bottom: 8px;
              text-align: left;
            }

            h4 {
              font-size: 24px;
              margin: 20px 0 10px;
            }

            p {
              font-size: 22px;
              line-height: 1.6;
              width: auto;
            }

            ul li {
              font-size: 22px;
              margin-bottom: 10px;
              line-height: 1.6;
            }
          }
        }
      }
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

</style>